// extracted by mini-css-extract-plugin
export default {"leadReport":"LeadReport_leadReport__IdBJP","controlPanel":"LeadReport_controlPanel__FDXYk","scrollable":"LeadReport_scrollable__39lb-"};